// extracted by mini-css-extract-plugin
module.exports = {"price":"UseCaseUpdateApi_price__30c6-","heartbeat":"UseCaseUpdateApi_heartbeat__2xOf5"};